import store, { Store } from './store'

export const stores = { store }
export { Store }
